(function ($, Drupal) {
  Drupal.behaviors.wrappingTables = {
    attach: function(context){

      var table = $("table");
      table.wrap("<div class='table-wrapper'></div>");

      // Click event on any focusable element.
      $(document).keydown(function(event){
        var keyCode = (event.keyCode ? event.keyCode : event.which);
        if (keyCode == 13) {
          $(document.activeElement).trigger('click');
        }
      });

    }
  }
})(jQuery, Drupal);

jQuery(() => {
  if (jQuery('.webform-submission-naa-study-application-form .webform-progress').length > 0) {
    jQuery('.webform-submission-naa-study-application-form .webform-progress').prepend(jQuery('.webform-submission-naa-study-application-form #edit-title'));
    jQuery('.webform-submission-naa-study-application-form .webform-progress').prepend(jQuery('.webform-submission-naa-study-application-form #edit-description-text'));
  }

  if (jQuery('#naa-study-form-head').length <= 0 && jQuery('.webform-submission-naa-study-application-form').length > 0) {
    jQuery('.layout-container header').css({'background-image': 'url(/themes/custom/defender/images/naa-bg-2.jpg)'});
  }
  
  const link = document.querySelector(".webform-submission-naa-study-application-form .form-item-apply-data a");
  if (link) {
    link.setAttribute('target', '_blank');
  }
});
